import { useEffect, useMemo, useState } from 'react';
import { notificationService } from '../services';

const formatTimeAgo = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);

  if (diffInSeconds < 60) return 'Agora mesmo';
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} min atrás`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hora(s) atrás`;
  return `${Math.floor(diffInSeconds / 86400)} dia(s) atrás`;
};

export default function useNotifications() {
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        const data = await notificationService.list();
        if (!data.success) return;

        const formattedNotifications = data.notifications.map((notif) => ({
          id: notif.id,
          type: notif.type,
          message: notif.message,
          time: formatTimeAgo(notif.created_at),
          read: notif.read || false
        }));

        setNotifications(formattedNotifications);
      } catch (error) {
        console.error('Erro ao carregar notificações:', error);
      }
    };

    loadNotifications();
  }, []);

  const unreadCount = useMemo(() => notifications.filter((n) => !n.read).length, [notifications]);

  const markNotificationAsRead = async (id) => {
    try {
      await notificationService.markRead(id);

      setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, read: true } : n)));
    } catch (error) {
      console.error('Erro ao marcar notificação:', error);
    }
  };

  const clearAllNotifications = async () => {
    try {
      await notificationService.clearAll();

      setNotifications([]);
    } catch (error) {
      console.error('Erro ao limpar notificações:', error);
    }
  };

  return {
    notifications,
    showNotifications,
    setShowNotifications,
    unreadCount,
    markNotificationAsRead,
    clearAllNotifications
  };
}
